'use client';

import { useEffect } from 'react';

/**
 * Adds class `in` to any descendant `.reveal` element when it enters the
 * viewport, then unobserves it. Mirrors the IntersectionObserver behavior
 * of the design bundle's app.jsx.
 */
export function useReveal(): void {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, io) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
